/**
 * Contenedor de Gráfica
 * Due: 3 de Junio
 */
import React, { useState } from "react";

// info: explanation shown under the title when the "i" next to it is clicked.
const ChartCard = ({ titulo, children, className = "", info }) => {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div
      className={`card p-3 shadow mt-2 mb-2 ${className}`}
      style={{ borderRadius: 10 }}
    >
      <div className="container-fluid pt-2 px-0">
        {titulo && titulo !== null && (
          <h4 className="px-3 d-flex align-items-center">
            {titulo}
            {info && (
              <button
                type="button"
                className={`btn btn-sm rounded-circle ms-2 p-0 ${
                  showInfo ? "btn-primary" : "btn-outline-primary"
                }`}
                style={{ width: 24, height: 24, fontSize: 12 }}
                title="¿Cómo se calcula?"
                onClick={() => setShowInfo(!showInfo)}
              >
                <i className="fa fa-info" />
              </button>
            )}
          </h4>
        )}
        {info && showInfo && (
          <div
            className="small text-muted mx-3 mb-3 p-2 rounded bg-light"
            style={{ borderLeft: "3px solid var(--primary)" }}
          >
            {info}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default ChartCard;
